module.exports = __webpack_public_path__ + "static/img/hs_js_11.2fc8cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hs/hs_js_11.png
// module id = qWew
// module chunks = 1